import React from 'react';
import { Chat as chatIcon } from '@s2/icons/dist';
import { useChatWidgetContext } from '@/widget/services/useChatWidgetContext';
import styles from './WidgetIcon.module.scss';

function WidgetIcon() {
  const { settings, store } = useChatWidgetContext();
  const { color, textColor } = settings;
  const { setOpen, setTouched } = store.getState();

  const handleClick = () => {
    setOpen(true);
    setTouched(true);
  };

  return (
    <div
      style={{ backgroundColor: color, color: textColor }}
      className={styles.icon}
      onClick={handleClick}
    >
      <div className={styles.svg}>{chatIcon()}</div>
    </div>
  );
}

export default WidgetIcon;
